import {useTranslation} from 'react-i18next';
import {Control, UseFormWatch, UseFormSetValue} from 'react-hook-form';
import AppMUIAutocomplete from '../../../../../../../components/common/AppMUIAutoComplete';
import {FormDataType, TimeType} from '../../../types';
import {SVG} from '../../../../../../../constants/assetLists';
import AppTextInput from '../../../../../../../components/common/AppTextInput';

type Props = {
  index: number;
  control: Control<FormDataType>;
  watch: UseFormWatch<FormDataType>;
  setValue: UseFormSetValue<FormDataType>;
};

function TimeField({index, watch, setValue}: Props) {
  const {t} = useTranslation();

  const timeTypeOptions = [
    {value: 'single', label: t('forms.dialog.time.single')},
    {value: 'range', label: t('forms.dialog.time.range')},
  ];

  const timeType = watch(`questions.${index}.timeType` as any) ?? 'single';

  return (
    <div className="flex items-center gap-2">
      <img
        src={SVG.clockIcon}
        alt={'clock'}
        className="w-[20px] h-[20px] object-contain"
      />

      <div className="flex-1">
        <AppMUIAutocomplete
          size="small"
          options={timeTypeOptions}
          value={
            timeTypeOptions.find(opt => opt.value === timeType) ||
            timeTypeOptions[0]
          }
          getOptionLabel={option => option.label}
          onChange={(_, newValue) => {
            if (newValue) {
              setValue(
                `questions.${index}.timeType` as any,
                newValue.value as TimeType,
                {
                  shouldDirty: true,
                },
              );
            }
          }}
          disableClearable
        />
      </div>

      {/* Time Preview */}
      <div className="flex-1">
        <AppTextInput
          type="text"
          placeholder={
            timeType === 'single'
              ? t('forms.dialog.dateTime.time')
              : t('forms.dialog.dateTime.from')
          }
          disabled
          py="py-[12px]"
          className="border-none"
          endIcon={
            <img
              src={SVG.clockIcon}
              alt={'calendar'}
              className="w-[18px] h-[20px] object-contain"
            />
          }
        />
      </div>

      <div className="flex-1">
        {timeType !== 'single' && (
          <AppTextInput
            type="text"
            placeholder={t('forms.dialog.dateTime.to')}
            disabled
            className="border-none"
            py="py-[12px]"
            endIcon={
              <img
                src={SVG.clockIcon}
                alt={'calendar'}
                className="w-[18px] h-[20px] object-contain"
              />
            }
          />
        )}
      </div>
    </div>
  );
}

export default TimeField;
